import Vue from 'vue'
import Vuex from 'vuex'

import {setItem, remove} from '@/lib/local-storage'
import {adminNavigations, userNavigations} from '@/_nav'
import {mobileDenormalize} from '@/lib/utils'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    $userInfo: null,
    loading: false,
    $offline: false,
    $account: null,
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    drawer: null
  },
  getters: {
    userInfo(state) {
      const account = state.$account?.account
      if (!account) return null
      return account
    },
    loading(state) {
      return state.loading
    },
    drawer(state) {
      return state.drawer
    },
    isPortal() {
      return window.location.origin.includes('portal.')
    },
    navigationsItems(state, getters) {
      const isConsular = !!getters.consularInfo
      console.log(getters)
      if (getters.isPortal) {
        if (isConsular) {
          return userNavigations.filter((item) => item.consular)
        }
        return userNavigations
      } else {
        return adminNavigations.concat(userNavigations)
      }
    },
    consularInfo(state) {
      const account = state.$account
      if (!account) return false
      return account.consularInfo
    },
    consularFullName(state, getters) {
      const consularInfo = getters.consularInfo
      if (!consularInfo) return ''
      const {firstName, lastName} = consularInfo
      return `${firstName} ${lastName}`
    },
    userFullName(state) {
      const account = state.$account?.account
      if (!account) return ''

      if (account.fullName) {
        return account.fullName
      } else if (account.firstName || account.lastName) {
        const firstName = account.firstName || ''
        const lastName = account.lastName || ''
        return `${firstName} ${lastName}`
      }
      return mobileDenormalize(account.mobile)
    }
  },
  mutations: {
    UPDATE_ACCOUNT({$account}, {user}) {
      $account.account.firstName = user.firstName
      $account.account.lastName = user.lastName
      $account.account.fullName = `${user.firstName || ''} ${user.lastName || ''}`
      this.commit('SET_ACCOUNT', $account)
    },
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload
    },
    SET_ACCOUNT(state, payload) {
      state.$account = payload
      setItem('ACCOUNT', payload)
    },
    SET_OFFLINE(state) {
      state.$offline = true
    },
    LOGOUT(state) {
      if (state.$account) {
        state.$account = null
        remove('ACCOUNT')
      }
    },
    SET_LOCALE: (state, {value, i18n}) => {
      state.$locale = value

      i18n.locale = value
      setItem('LOCALE', value)
    }
  },
  actions: {}
})
